import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Checkbox } from 'ui-components/components/checkbox';
import { noop } from 'ui-components/default-props/noop';
import style from './selectable-service.module.less';

const SelectableService = ({ name = '', className = '', checked = false, onCheck = noop }) => (
  <button className={classnames(style['selectable-service'], className)} onClick={onCheck}>
    <Checkbox checked={checked} className={style['check-box']} label={name} onChange={noop} />
  </button>
);

SelectableService.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  checked: PropTypes.bool,
  onCheck: PropTypes.func,
};

export default SelectableService;
